<template>
  <div class="add-machine-booking height-100 flex-col pad-10 pad-top-0">

    <!-- SELECT MACHINE -->
    <b-modal :active.sync="showMachineModal">
      <div class="box flex-col" style="max-width: 400px; margin: 0 auto;">
        <div class="font-size-120 bold margin-bottom-5">
          Select Machine
        </div>
        <b-field grouped expanded>
          <b-field expanded>
            <p class="control has-icons-left">
              <input class="input" v-model="searchStr" placeholder="search machines" />
              <span class="icon is-small is-left">
                <fa icon="search" />
              </span>
            </p>
          </b-field>
        </b-field>
        <div class="flex-1 overflow-y-auto" style="border: solid 1px #ccc; margin-top: -15px; min-height: 200px; max-height: 50vh">
          <table class="table is-striped is-narrow is-hoverable width-100">
            <tbody>
              <tr v-for="machine in filteredMachines" :key="machine._id" class="pointer" @click="onSelectMachine(machine)">
                <td>{{ machine.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <!-- SELECT CUSTOMER -->
    <b-modal :active.sync="showCustomerModal">
      <div class="box flex-col" style="max-width: 400px; margin: 0 auto;">
        <div class="font-size-120 bold margin-bottom-5">
          Select Customer
        </div>
        <b-field grouped expanded>
          <b-field expanded>
            <p class="control has-icons-left">
              <input class="input" v-model="searchStr" placeholder="search customers" />
              <span class="icon is-small is-left">
                <fa icon="search" />
              </span>
            </p>
          </b-field>
          <p class="control">
            <button class="button is-success" @click="onAddCustomer()"><fa icon="plus" /></button>
          </p>
        </b-field>
        <div class="flex-1 overflow-y-auto" style="border: solid 1px #ccc; margin-top: -15px; min-height: 200px; max-height: 50vh">
          <table class="table is-striped is-narrow is-hoverable width-100">
            <tbody>
              <tr v-for="customer in filteredCustomers" :key="customer._id" class="pointer">
                <td @click="onSelectCustomer(customer)">{{ customer.firstName }}</td>
                <td @click="onSelectCustomer(customer)">{{ customer.lastName }}</td>
                <td @click="onSelectCustomer(customer)">{{ customer.phone }}</td>
                <td @click="onEditCustomerDetails(customer)" class="right" style="width: 30px; text-align: right;"><fa icon="edit" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <!-- CUSTOMER FORM -->
    <b-modal :active.sync="showCustomerForm">
      <div class="box flex-col" style="max-width: 400px; margin: 0 auto;">
        <div class="font-size-120 bold margin-bottom-5">
          {{ editCustomer ? 'Edit' : 'Add' }} Customer
        </div>
        <div class="flex-1">
          <sdf-form :fields="customerFields" :data="editCustomer" ref="customerForm" />
        </div>
        <div class="buttons margin-top flex">
          <div class="flex-1">
            <button class="button is-small" @click="showCustomerForm = false">Close</button>
          </div>
          <div>
            <button v-if="editCustomer" class="button is-small is-danger" :class="{'is-loading': submittingCustomer}" @click="onDeleteCustomer()">Delete</button>
            <button class="button is-small is-info" :class="{'is-loading': submittingCustomer}" @click="onSubmitCustomer()">{{  editCustomer ? 'Update' : 'Add'}}</button>
          </div>
        </div>

      </div>
    </b-modal>

    <!-- MACHINE -->
    <div class="edit-field bold">
      <div class="flex">
        <div>
          <button v-if="!machine" class="button margin-right-10" @click="onEditMachine()"><fa icon="bars" /></button>
        </div>
        <div class="flex-1">
          <div class="font-size-70">MACHINE</div>
          <template v-if="selectedMachine">{{ selectedMachine.name }}</template>
          <template v-else><span class="has-text-grey-light bold">SELECT MACHINE</span></template>
        </div>
      </div>
    </div>

    <!-- CUSTOMER -->
    <div class="edit-field margin-top">
      <div class="flex">
        <div>
          <button v-if="!machine" class="button margin-right-10" @click="onEditCustomer()"><fa icon="bars" /></button>
        </div>
        <div class="flex-1">
          <div class="font-size-70">CUSTOMER</div>
          <template v-if="selectedCustomer">
            <div class="flex">
              <div class="flex-1">
                <div class="bold">{{ selectedCustomer | name }}</div>
                <div class="font-size-80">{{ selectedCustomer.phone }}</div>
              </div>
              <div>
                <button class="button is-small" @click="onEditCustomerDetails(selectedCustomer)"><fa icon="edit" /></button>
              </div>
            </div>
          </template>
          <template v-else><span class="has-text-grey-light bold">SELECT CUSTOMER</span></template>
        </div>
      </div>
    </div>

    <div class="pad-top-10 bold">
      <template v-if="fromTimestamp && toTimestamp">
        {{ fromTimestamp | unixToDateString }} to {{ toTimestamp  | unixToDateString }}
      </template>
      <template v-else>Select Dates</template>
    </div>

    <div class="dates pad-top-5">
        <b-datepicker
          :mobile-native="false"
          v-model="dates"
          icon-pack="fas"
          inline
          range
        />

        <div class="pad-top-10 bold">
          Comments
          <b-input type="textarea" v-model="comments" />
        </div>

        <div class="buttons pad-top-10">
          <button class="button is-info" :class="{'is-loading': submitting}" @click="onSubmitDates()" :disabled="!selectedMachine || !selectedCustomer || dates.length !== 2">
            Submit Booking
          </button>
          <button class="button" @click="$emit('close')">Cancel</button>
        </div>
    </div>

    <br />
    <br />
    <br />

  </div>
</template>

<style>
  .add-machine-booking .edit-field {
    background-color: #eee;
    padding: 10px;
    border-radius: 7px;
  }
</style>

<script>

import SdfForm from '@/components/SdfForm'

export default {
  props: ['machine'],
  components: { SdfForm },
  data () {
    return {
      dates: [],
      machines: null,
      selectedMachine: null,
      showMachineModal: false,
      customers: null,
      selectedCustomer: null,
      editCustomer: null,
      showCustomerModal: false,
      showCustomerForm: false,
      customerFields: [
        { key: 'firstName', required: true },
        { key: 'lastName' },
        { key: 'phone' },
        { key: 'email', input: 'email' },
        { key: 'comments', input: 'textarea' }
      ],
      comments: '',
      searchStr: '',
      submitting: false,
      submittingCustomer: false,
      fromTimestamp: 0,
      toTimestamp: 0
    }
  },
  watch: {
    dates () {
      this.fromTimestamp = this.$moment(this.dates[0]).unix()
      this.toTimestamp = this.$moment(this.dates[1]).unix()
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    filteredMachines () {
      if (!this.showMachineModal || !this.machines) return []
      let str = this.searchStr.trim().toLowerCase()
      return this.machines.filter(machine => {
        return machine.name.toLowerCase().indexOf(str) >= 0
      })
    },
    filteredCustomers () {
      if (!this.showCustomerModal || !this.customers) return []
      let str = this.searchStr.trim().toLowerCase()
      return this.customers.filter(customer => {
        return `${customer.firstName} ${customer.lastName}`.toLowerCase().indexOf(str) >= 0
      })
    }
  },
  created () {
    if (this.machine) {
      this.selectedMachine = this.machine
    } else {
      this.subs.machines = this.$fs.collection('machines')
        .where('hireOut', '==', true)
        .onSnapshot(snapshot => {
          let machines = this.$utils.snapshotToArr(snapshot)
            .map(machine => {
              return {
                _id: machine._id,
                name: `${machine.name}`
              }
            })
          this.machines = machines
        })
    }

    this.subs.machineBookingCustomers = this.$fs.collection('machineBookingCustomers')
      .onSnapshot(ss => {
        this.customers = this.$utils.snapshotToArr(ss)
      })
  },
  methods: {
    onEditMachine () {
      this.searchStr = ''
      this.showMachineModal = true
    },
    onSelectMachine (machine) {
      this.selectedMachine = machine
      this.showMachineModal = false
    },
    onEditCustomer (customer) {
      this.searchStr = ''
      this.showAddCustomer = false
      this.showCustomerModal = true
    },
    onSelectCustomer (customer) {
      this.selectedCustomer = customer
      this.showCustomerModal = false
    },
    onAddCustomer () {
      this.editCustomer = null
      this.showCustomerForm = true
    },
    onEditCustomerDetails (customer) {
      this.editCustomer = customer
      this.showCustomerForm = true
    },
    async onSubmitCustomer () {
      let form = this.$refs.customerForm
      let data = form.submit()
      if (!data) return
      this.submittingCustomer = true
      console.log(data)
      try {
        if (this.editCustomer) {
          console.log(data)
          await this.$fs.doc(`/machineBookingCustomers/${this.editCustomer._id}`)
            .update(data)
          if (this.selectedCustomer && this.selectedCustomer._id === this.editCustomer._id) {
            this.selectedCustomer = data
          }
          this.showCustomerForm = false
        } else {
          let res = await this.$fs.collection('machineBookingCustomers')
            .add(data)
          data._id = res.id
          this.selectedCustomer = data
          this.showCustomerForm = false
          this.showCustomerModal = false
        }
      } catch (error) {
        this.$showError(error)
      }
      this.submittingCustomer = false
    },
    async onDeleteCustomer () {
      let confirmed = await this.$confirm({
        type: 'is-danger',
        title: 'Deleting Machine Hire Customer',
        message: `Are you sure you want to delete this customer<br /><b>${this.editCustomer.firstName} ${this.editCustomer.lastName}</b>`
      })
      if (!confirmed) return

      this.submittingCustomer = true
      await this.$wait(1000)
      try {
        await this.$fs.doc(`/machineBookingCustomers/${this.editCustomer._id}`)
          .delete()
        if (this.selectedCustomer && this.selectedCustomer._id === this.editCustomer._id) {
          this.selectedCustomer = null
        }
        this.showCustomerForm = false
      } catch (error) {
        this.$showError(error)
      }
      this.submittingCustomer = false
    },
    async onSubmitDates () {
      this.submitting = true
      if (!await this.checkOverlap()) {
        this.submitting = false
        return
      }
      let booking = {
        machine: {
          _id: this.selectedMachine._id,
          name: this.selectedMachine.name
        },
        comments: this.comments.trim(),
        customerId: this.selectedCustomer._id,
        customer: this.selectedCustomer,
        bookingTimestamp: this.$moment().unix(),
        fromTimestamp: this.$moment(this.dates[0]).startOf('day').unix(),
        toTimestamp: this.$moment(this.dates[1]).startOf('day').unix(),
        months: this.getMonths()
      }
      await this.$fs.collection('machineBookings').add(booking)
      this.submitting = false
      this.$emit('close', booking)
    },
    async checkOverlap () {
      const fromTimestamp = this.$moment(this.dates[0]).startOf('day').unix()
      try {
        let ss = await this.$fs.collection('machineBookings')
          .where('machine._id', '==', this.selectedMachine._id)
          .where('toTimestamp', '>=', fromTimestamp)
          .get()
        let bookings = this.$utils.snapshotToArr(ss)
        console.log('bookings', bookings)
        if (!bookings || !bookings.length) {
          return true
        }
        const toTimestamp = this.$moment(this.dates[1]).startOf('day').unix()
        for (const booking of bookings) {
          if (booking.fromTimestamp < toTimestamp) {
            return await this.$confirm({
              type: 'is-warning',
              title: 'Double Booked',
              message: `This booking overlaps with another booking. Please check the dates!`,
              confirmText: 'Book Anyway'
            })
          }
        }
        return true
      } catch (error) {
        this.$showError(error)
      }
      return false
    },
    getMonths () {
      let months = []
      let m = this.$moment(this.dates[0]).startOf('day')
      let toTimestamp = this.$moment(this.dates[1]).startOf('day').unix()
      let timestamp = m.unix()
      while (timestamp <= toTimestamp) {
        months.push(m.month())
        m.add(1, 'month')
        timestamp = m.unix()
      }
      return months
    }
  }
}
</script>
